module.exports = __webpack_public_path__ + "static/badges-b72483e6921e35e823a97ea68935246d.png";